import React, { useCallback, useEffect, useState } from 'react'

import { useSearchParams } from 'react-router-dom'

import { includesInsensitive } from "util/string"

import DefaultEntityCrud from 'components/form/DefaultEntityCrud';
import FormContent from 'components/form/FormContent';
import FormRow from 'components/form/FormRow';
import SelectInput from 'components/form/input/SelectInput';
import TextInput from 'components/form/input/TextInput';
import DebugObjComp from 'components/DebugObjComp'

import GrupoEntity from 'entity/Grupo'

const GrupoFormInter = (props) => {
    const [grupos, setGrupos] = useState([])
    const [, setfilteredGrupos] = useState([])

    const { nome } = props.values
    const [searchParams] = useSearchParams()
    const searchUid = searchParams.get("uid")

    const loadProdutos = useCallback(async () => {
        // let result = await fetchArray(GrupoEntity.getAll())

        // setGrupos(result)

        // if (nome && nome.length) {
        //     setfilteredGrupos(result.filter(g => includesInsensitive(g.nome, nome)))
        // } else if (searchUid) {
        //     setfilteredGrupos(result.filter(g => g.uid === searchUid))
        // } else {
        //     setfilteredGrupos(result)
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        loadProdutos()
    }, [loadProdutos])

    // lista e função de filtrar
    useEffect(() => {
        let i = grupos.map(g => g.uid).indexOf(searchUid)

        // grupo atualizado
        let obj = props.values
        obj.nome = obj.nome?.toUpperCase()
        if (searchUid) {
            obj.uid = searchUid
        }

        // >>> trabalhando com a tabela <<<
        // não existe o item na tabela
        if (i === -1) {
            // acabou de salvar o item no bd, então adicioná-lo na tabela
            if (searchUid) {
                setGrupos([obj, ...grupos])
            }
        }
        // existe o item na tabela
        else {
            let a = grupos
            a[i] = obj

            setGrupos(a)
        }

        // >>> trabalhando com o filtro <<<
        if (nome) {
            setfilteredGrupos(grupos.filter(g => includesInsensitive(g.nome, nome)))
        } else {
            setfilteredGrupos(grupos)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nome, searchUid, grupos])

    return (
        <>
            <FormContent sx={{ m: 1 }}>
                <FormRow>
                    <SelectInput
                        sx={{ flex: 0.5 }}
                        name="status"
                        label="STATUS"
                        options={["ATIVO", "INATIVO"]}
                    />
                    <TextInput sx={{ flex: 2 }} name="nome" label="NOME DO GRUPO" required />
                </FormRow>
            </FormContent>

            {/* <DataTable
                columns={GrupoEntity.searchColumns}
                rows={filteredGrupos}
                autoHeight
                // onRowClick={row => navigate("/grupo?uid=" + row.uid)}
                sx={{
                    "& .MuiDataGrid-row:hover": {
                        cursor: "pointer",
                    },
                }}
            /> */}
            <DebugObjComp colection={GrupoEntity.collectionUID} uidObj={props.values.uid} values={props.values} />
        </>
    )
}

export default function GrupoForm() {
    return (
        <DefaultEntityCrud
            EntityClass={GrupoEntity}
            title={"Grupo"}
            routeForm="grupo"
            backRoute="consulta-grupo"
            formActions={{ novoForm: true, salvarForm: true, sairForm: true }}
            
        >
            {(props) => {
                return <GrupoFormInter {...props} />
            }}
        </DefaultEntityCrud>
    )
}